export const pagesTransMap: {[url: string]: string} = {
  "/performanceReport": "SAFETY EVENTS",
  "/trainRoute": "Train Route",
  "/systemHealth": "System Health",
  "/videos": "Videos",
  "/systemUsage": "System Usage",
  "/queueControl": "Queue Control",
  "/notifications": "Notifications",
}